import React, { Component } from 'react';
import Header from './components/Header';
import Home from './components/Home';
import Footer from './components/Footer';
import Fixedratebond from './pages/Fixedratebond';
import Error from './pages/Error';
import { BrowserRouter as Router, Switch, Route} from 'react-router-dom';

class App extends Component {
 
  render() {
    return (
      <div>
     <Router basename={'/best-savings-rates'}>
        <Header />

        <Switch>
        <Route exact path='/' component={Home}></Route>
        <Route exact path='/fixed-rate-bond/:id' component={Fixedratebond} ></Route>
        <Route component={Error}></Route>
        </Switch>

        <Footer />
        </Router>
      </div>
    );
  }
}

export default App;